import React from 'react';
import { FlagIcon } from './FlagIcon';

export const FlagPT = props => (
    <FlagIcon {...props} viewBox="0 0 512 512">
        <rect width="204.8" height="512" fill="#046A38" />
        <rect width="307.2" height="512" x="204.8" fill="#DA291C" />
    </FlagIcon>
);
